/**
 * User API endpoints — mirrors backend/app/api/v1/users.py
 * Router prefix: /users   Full path: /api/v1/users/...
 */
import { apiClient } from '../client'
import type {
  UserRead,
  UserProfileRead,
  UserUpdateMe,
  ProfileUpdateRequest,
  StreakResponse,
  StudentDashboardStats,
  StudentAnalyticsResponse,
} from '../types'

export const userApi = {

  // ─── Current User ───────────────────────────────────────────────────────────

  /** GET /users/me — get the authenticated user's full object */
  getMe: () =>
    apiClient.get<UserRead>('/users/me'),

  /** PUT /users/me — update full_name, phone, or date_of_birth */
  updateMe: (data: UserUpdateMe) =>
    apiClient.put<UserRead>('/users/me', data),

  // ─── Profile ────────────────────────────────────────────────────────────────

  /** GET /users/profile — get the authenticated user's learning profile */
  getProfile: () =>
    apiClient.get<UserProfileRead>('/users/profile'),

  /** PUT /users/profile — update interests, background_level, learning_style, etc. */
  updateProfile: (data: ProfileUpdateRequest) =>
    apiClient.put<UserProfileRead>('/users/profile', data),

  // ─── Analytics ──────────────────────────────────────────────────────────────

  /** GET /users/me/stats — dashboard stats: enrolled courses, completed, hours, avg score */
  getStats: () =>
    apiClient.get<StudentDashboardStats>('/users/me/stats'),

  /** GET /users/me/analytics — weekly progress chart, skill radar, recent activity feed */
  getAnalytics: () =>
    apiClient.get<StudentAnalyticsResponse>('/users/me/analytics'),

  // ─── Activity & Streak ──────────────────────────────────────────────────────

  /** POST /users/me/activity — idempotent ping: records one activity entry per calendar day */
  recordActivity: () =>
    apiClient.post<void>('/users/me/activity'),

  /** GET /users/me/streak — current_streak, best_streak, active_days, activity_dates */
  getStreak: () =>
    apiClient.get<StreakResponse>('/users/me/streak'),

  // ─── Account ────────────────────────────────────────────────────────────────

  /** DELETE /users/account — soft-delete the account (recoverable) */
  deleteAccount: () =>
    apiClient.delete<void>('/users/account'),
}
